<!--<p-tree [value]="tags" selectionMode="single"  (onNodeSelect)="onNodeSelect($event)" (onNodeExpand)="nodeExpand($event)"
[loading]="loading"
[contextMenu]="gf" [(selection)]="selectedNode" (onNodeContextMenuSelect)="nodeSelected($event)"></p-tree>-->

<div style="padding: 4px 8px 6px;">
  <span class="p-input-icon-left w-full">
    <i class="pi pi-search" style="font-size: 0.8rem;"></i>
    <input pInputText type="text" [(ngModel)]="peopleSearch" (ngModelChange)="onPeopleSearchChange()"
           placeholder="Find person..." style="width: 100%; font-size: 0.8rem; padding: 4px 4px 4px 28px; height: 28px;" />
  </span>
</div>

<p-tree [value]="tags" class="w-full md:w-30rem" [contextMenu]="gf" [loading]="loading">
  <ng-template let-node pTemplate="url">
    <a [href]="node.data" target="_blank" rel="noopener noreferrer" class="text-700 hover:text-primary">
      {{ node.label }}
    </a>
  </ng-template>
  <ng-template let-node pTemplate="default">
    @if (!node.data?.isUser && !node.data?.isPeopleFolder) {
      <span (click)="openCm($event, gf, node)"><i [class]="folderType[node.data?.tagType]?.['icon']" aria-hidden="true" style="margin-right: 15px; cursor: copy"></i></span>
    }
    @if (node.data?.isUser || node.data?.isPeopleFolder) {
      <span><i class="pi pi-users" aria-hidden="true" style="margin-right: 15px;"></i></span>
    }
    <b (click)="onNodeSelect(node)" style="cursor: pointer">{{ node.label }}</b>
  </ng-template>
</p-tree>

<p-contextMenu #gf appendTo="body" [model]="menuItems"></p-contextMenu>

